import { cn } from "@/lib/utils"
import React, { Suspense } from "react"
import { Loader } from "react-feather"

const SearchBar = React.lazy(() => import("@/components/SearchBar"))

export const SearchBarWrapper = ({
  isSearchOpen,
  setIsSearchOpen,
  className,
  showHeader,
}: {
  isSearchOpen: boolean
  setIsSearchOpen: (isSearchOpen: boolean) => void
  className?: string
  showHeader: boolean
}) => {
  const searchBar = isSearchOpen ? (
    <Suspense
      fallback={
        <div className={cn("flex justify-center py-10")}>
          <Loader className={cn("animate-spin")} size={32} />
        </div>
      }
    >
      <SearchBar
        isOpen={isSearchOpen}
        setIsSearchOpen={setIsSearchOpen}
        className={className}
        showHeader={showHeader}
      />
      <div
        className={cn(
          "h-0 ",
          "lg_h-[calc(100vh_-_80px)]",
          "absolute left-0 top-full  w-full bg-[rgba(0,0,0,.3)]"
        )}
      />
    </Suspense>
  ) : null

  return searchBar
}
